/**
* Before and After Shuffle JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Shuffle component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'before-and-after-shuffle',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      const sets = document.querySelectorAll( '.before-and-after-shuffle .bag-shuffle__wrapper' );
      let currentIndex = 0;
      const swapInterval = 5000;

      if ( sets.length === 0 ) return;

      sets.forEach( ( set, index ) => {
        set.style.display = index === 0 ? 'flex' : 'none';
        set.style.opacity = index === 0 ? '1' : '0';
      } );

      function swapSets() {
        gsap.to( sets[currentIndex], {
          opacity: 0,
          duration: 0.5,
          onComplete: () => {
            sets[currentIndex].style.display = 'none';
            currentIndex = ( currentIndex + 1 ) % sets.length;
            sets[currentIndex].style.display = 'flex';
            gsap.to( sets[currentIndex], {opacity: 1, duration: 0.5} );
          },
        } );
      }

      if ( sets.length > 1 ) {
        setInterval( swapSets, swapInterval );
      }
    },


    finalize: function() {},
  };

  app.registerComponent( 'before-and-after-shuffle', COMPONENT );
} )( app );

